export const company = {
  name: 'Cascade',
  supportEmail: 'help@gocascade.ai',
  privacyPolicyUrl: 'https://www.gocascade.ai/privacy-policy',
  termsOfServiceUrl: 'https://www.gocascade.ai/terms-and-conditions',
} as const;
